package analytics

import io.ktor.client.HttpClient
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.HttpTimeout
import kotlinx.browser.localStorage
import org.koin.core.module.Module
import org.koin.dsl.module

actual fun analyticsPlatformModule(): Module = module {
    single<AnalyticsPreferences> {
        JsAnalyticsPreferences(get<AnalyticsConfig>().appName)
    }
    single { AnalyticsHttpEngine(jsAnalyticsHttpClient()) }
}

private fun jsAnalyticsHttpClient(): HttpClient = HttpClient(Js) {
    install(HttpTimeout) {
        requestTimeoutMillis = 15_000
        connectTimeoutMillis = 10_000
        socketTimeoutMillis = 15_000
    }
    expectSuccess = false
}

private class JsAnalyticsPreferences(
    appName: String,
) : AnalyticsPreferences {
    private val prefix = "${appName}_analytics."

    override fun getString(key: String): String? = localStorage.getItem(prefix + key)

    override fun putString(key: String, value: String) {
        localStorage.setItem(prefix + key, value)
    }

    override fun remove(key: String) {
        localStorage.removeItem(prefix + key)
    }
}
